import { Controller } from '@hotwired/stimulus'

// Simple click-to-toggle controller for showing/hiding elements
//
// Usage (basic):
//   <div data-controller="toggle">
//     <a href="#" data-action="click->toggle#toggle">Toggle</a>
//     <div data-toggle-target="toggleable" class="d-none">
//       Hidden content that will be shown/hidden on click
//     </div>
//   </div>
//
// Usage (named groups for independent toggles):
//   <div data-controller="toggle">
//     <a href="#" data-action="click->toggle#toggle" data-toggle-name-param="first">Toggle First</a>
//     <a href="#" data-action="click->toggle#toggle" data-toggle-name-param="second">Toggle Second</a>
//     <div data-toggle-target="toggleable" data-toggle-name-value="first" class="d-none">First section</div>
//     <div data-toggle-target="toggleable" data-toggle-name-value="second" class="d-none">Second section</div>
//   </div>
//
export default class extends Controller {
  static targets = ['toggleable']

  toggle(event) {
    event?.preventDefault()
    const name = event.params?.name
    this.toggleableTargets.forEach((target) => {
      if (!name || target.dataset.toggleNameValue === name) {
        target.classList.toggle('d-none')
      }
    })
  }
}
